import { Button } from "antd";
import { useState } from "react";

export const ClickLoadingButton = (props) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  return (
    <Button
      {...props}
      loading={loading}
      disabled={disabled || loading || props.disabled}
      onClick={async (e) => {
        setLoading(true);
        if (props.onClick) {
          console.log("disabled : ", true);
          await props.onClick(e);
          setDisabled(true);
        }
        setLoading(false);
      }}
    >
      {props.children}
    </Button>
  );
};
